import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { Grid, Typography } from '@mui/material';
import { ShowDefinedEntriesOnlyOpts } from '../../../types/AppTypes';
import { ObjectDetailCard } from '../../../v2/components/generic/ObjectView/ObjectDetailCard';
const HardwareDefinitions = {
    remoteEnabled: {
        key: 'remoteEnabled',
        label: 'Remote',
        type: AppValueTypes.BOOLEAN,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    firmwareVersion: {
        key: 'firmwareVersion',
        label: 'Firmware Version',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    GWUserID: {
        key: 'GWUserID',
        label: 'GW User ID',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    GWUserPW: {
        key: 'GWUserPW',
        label: 'GW User PW',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    LastUpdate: {
        key: 'LastUpdate',
        label: 'Last Update',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
// const BackhaulDefinitions: string[] = ['backhaul', 'WAPESSID', 'modemModel', 'modemSerialNumber', 'SIMNumber', 'SIMPUK'];
const BackhaulDefinitions = {
    backhaul: {
        key: 'backhaul',
        label: 'Backhaul',
        type: AppValueTypes.ENUM,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    WAPESSID: {
        key: 'WAPESSID',
        label: 'WAP ESSID',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    modemModel: {
        key: 'modemModel',
        label: 'Modem Model',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    modemSerialNumber: {
        key: 'modemSerialNumber',
        label: 'Modem Serial Number',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    SIMNumber: {
        key: 'SIMNumber',
        label: 'SIM Number',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    SIMPUK: {
        key: 'SIMPUK',
        label: 'SIM PUK',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
const ErrorDefinitions = {
    lastSendPeriod: {
        key: 'lastSendPeriod',
        label: 'Last Send Period',
        type: AppValueTypes.NUMBER,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    _permittedAWOL: {
        key: '_permittedAWOL',
        label: 'Max AWOL (mins)',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
const NetworkDefinitions = {
    nwID: {
        key: 'nwID',
        label: 'NW ID',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    ports: {
        key: 'ports',
        label: 'Ports',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    channels: {
        key: 'channels',
        label: 'Channels',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
    frequency: {
        key: 'frequency',
        label: 'Frequency',
        type: AppValueTypes.STRING,
        editable: false,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
const GatewayConfigurationTab = (props) => {
    const { gateway, mostProximateCustomer, transactionFunctions, userFunctions } = props;
    return (_jsxs("div", { children: [_jsxs(Typography, { component: "h6", variant: "h6", children: ["EUI: ", gateway.eui] }), _jsxs(Grid, { container: true, spacing: 1, children: [_jsxs(Grid, { size: 6, children: [_jsx(Typography, { component: "h4", variant: "h6", children: "Hardware" }), _jsx(ObjectDetailCard, { mostProximateCustomer,
                                matchedPrimary: gateway,
                                userFunctions,
                                transactionFunctions,
                                showContextSubCard: false,
                                definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
                                viewDefinition: HardwareDefinitions })] }), _jsxs(Grid, { size: 6, children: [_jsx(Typography, { component: "h4", variant: "h6", children: "Backhaul" }), _jsx(ObjectDetailCard, { mostProximateCustomer,
                                matchedPrimary: gateway,
                                userFunctions,
                                transactionFunctions,
                                showContextSubCard: false,
                                definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
                                viewDefinition: BackhaulDefinitions })] }), _jsxs(Grid, { size: 6, children: [_jsx(Typography, { component: "h4", variant: "h6", children: "Errors" }), _jsx(ObjectDetailCard, { mostProximateCustomer,
                                matchedPrimary: gateway,
                                userFunctions,
                                transactionFunctions,
                                showContextSubCard: false,
                                definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
                                viewDefinition: ErrorDefinitions })] }), _jsxs(Grid, { size: 6, children: [_jsx(Typography, { component: "h4", variant: "h6", children: "Network" }), _jsx(ObjectDetailCard, { mostProximateCustomer,
                                matchedPrimary: gateway,
                                userFunctions,
                                transactionFunctions,
                                showContextSubCard: false,
                                definedEntriesOnlyOpt: ShowDefinedEntriesOnlyOpts.Yes,
                                viewDefinition: NetworkDefinitions })] })] })] }));
};
export default GatewayConfigurationTab;
